import { useEffect, useState } from "react";
import { Mail, Save, Send, Bell } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function Settings() {
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setEmail(r.data.notification_email || ""));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", { notification_email: email });
      toast.success("Paramètres enregistrés");
    } catch {
      toast.error("Échec de l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  const sendNow = async () => {
    if (!email) {
      toast.error("Enregistrez d'abord une adresse e-mail");
      return;
    }
    setSending(true);
    try {
      const { data } = await api.post("/notifications/run");
      if (data.sent) toast.success(`E-mail envoyé (${data.urgent_count} contrôle(s) urgent(s))`);
      else toast.info("Aucun contrôle urgent à signaler pour le moment");
    } catch {
      toast.error("Échec de l'envoi de l'e-mail");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ml-64 p-8 min-h-screen">
      <div className="mb-8 mc-slide-up">
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">Paramètres</h1>
        <p className="text-slate-500 font-medium mt-1">Rappels automatiques par e-mail</p>
      </div>

      <div className="max-w-xl nb-card p-6 mc-pop">
        <div className="flex items-center gap-2 mb-4">
          <Bell size={20} strokeWidth={2.5} className="text-[#4F46E5]" />
          <h2 className="font-heading font-black text-xl">Alertes contrôle technique</h2>
        </div>
        <p className="text-sm text-slate-600 font-medium mb-5">
          Chaque semaine (lundi matin), un e-mail est envoyé pour les contrôles techniques
          <b className="text-[#EF4444]"> urgents (rouge, moins de 15 jours)</b>.
        </p>

        <label className="text-xs font-bold uppercase tracking-wider text-slate-600 mb-1 block">
          Adresse e-mail de notification
        </label>
        <div className="relative mb-5">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} strokeWidth={2.5} />
          <input
            data-testid="settings-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="alertes@exemple.fr"
            className="nb-input w-full pl-11 pr-4 py-3 font-medium"
          />
        </div>

        <div className="flex gap-3">
          <button
            data-testid="settings-save-button"
            onClick={save}
            disabled={saving}
            className="flex items-center gap-2 bg-[#4F46E5] text-white font-bold px-5 py-3 rounded-xl nb-btn disabled:opacity-60"
          >
            <Save strokeWidth={2.5} size={18} /> {saving ? "..." : "Enregistrer"}
          </button>
          <button
            data-testid="settings-test-button"
            onClick={sendNow}
            disabled={sending}
            className="flex items-center gap-2 bg-[#FBBF24] font-bold px-5 py-3 rounded-xl nb-btn disabled:opacity-60"
          >
            <Send strokeWidth={2.5} size={18} /> {sending ? "Envoi..." : "Envoyer maintenant"}
          </button>
        </div>
      </div>
    </div>
  );
}
